var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-content-composer-options-collapse"},[_c('form-input',{attrs:{"label":_vm.$t('form_content_composer.options_input.label.label'),"value":_vm.value.label,"required":!['file'].find(type => type === _vm.value.type)},on:{"input":function($event){return _vm.onInput('label', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }